<div class="w-full min-w-0 relative">
  @if (label()) {
  <label [for]="name()" class="block text-sm font-medium text-black mb-1">
    {{ label() }}
    @if (required()) {
    <span class="text-error">*</span>
    }
  </label>
  }

  <div class="relative min-w-0">
    @if (icon()) {
    <div class="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none z-10">
      <hugeicons-icon [icon]="icon()" [size]="22" color="currentColor" [strokeWidth]="1.5"></hugeicons-icon>
    </div>
    }

    <button class="placeholder-text placeholder:w-[70%]" type="button" [id]="name()" [disabled]="isDisabled()"
      (click)="toggleDropdown()" [class]="triggerClasses()" [attr.aria-label]="label() || placeholder()"
      [attr.aria-expanded]="isOpen()" aria-haspopup="listbox"
      [attr.aria-invalid]="error() !== null"
      [attr.aria-describedby]="error() || hint() ? name() + '-help' : null">
      <span [title]="getDisplayText()" [class]="getTriggerSpanClasses()">
        {{ getDisplayText() }}
      </span>
      <div class="absolute right-1 top-0 bottom-0 flex items-center gap-0.5">
        @if (clearable() && hasValue() && !readOnly()) {
        <button type="button" (click)="clearSelection($event)" [disabled]="isDisabled()"
          class="p-0.5 cursor-pointer flex items-center justify-center rounded  text-text-muted hover:text-text-strong transition-colors disabled:opacity-50 disabled:pointer-events-none"
          aria-label="Clear selection">
          <hugeicons-icon [icon]="Cancel01Icon" [size]="12" color="currentColor" [strokeWidth]="1.5"></hugeicons-icon>
        </button>
        }
        <div class="pointer-events-none flex items-center justify-center">
          <hugeicons-icon [icon]="ArrowDown01Icon" [size]="16" color="currentColor"
            [strokeWidth]="1.5"></hugeicons-icon>
        </div>
      </div>
    </button>

    @if (isOpen()) {
    <div class="bg-surface border border-border-subtle rounded-lg shadow-lg overflow-hidden select-dropdown-panel"
      [class.select-dropdown-panel--up]="openUpward()"
      role="listbox" [attr.aria-label]="label() || placeholder()"
      [ngStyle]="dropdownStyle()"
      [style.max-height]="maxHeight()" [style.min-width]="minWidth()">
      @if (searchable() && !readOnly()) {
      <div class="p-2 border-b border-border-subtle sticky top-0 bg-surface">
        <div class="relative">
          <hugeicons-icon [icon]="Search01Icon" [size]="16" color="currentColor" [strokeWidth]="1.5"
            class="absolute left-1 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none"></hugeicons-icon>
          <input type="text" [value]="searchQuery()" (input)="onSearchInput($event)" (keydown)="onSearchKeydown($event)"
            [placeholder]="searchPlaceholder()"
            class="w-full pl-8 pr-3 py-2 text-sm rounded-md border border-border-subtle bg-bg text-text-strong placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
            (click)="$event.stopPropagation()" />
        </div>
      </div>
      }
      <div class="overflow-y-auto p-1 pb-4" [style.max-height]="searchable() ? '240px' : maxHeight()">
        @if (loading()) {
        <div class="px-3 py-6 text-center text-sm text-text-muted">
          Loading...
        </div>
        } @else if (hasNoResults()) {
        <div class="px-3 py-6 text-center text-sm text-text-muted">
          No results found
        </div>
        } @else {
        @for (option of filteredOptions(); track option.value) {
        <button type="button" role="option" [attr.aria-selected]="isSelected(option.value)"
          [disabled]="option.disabled || isDisabled() || readOnly()" (click)="selectOption(option)"
          class="w-full text-left flex items-center px-3 py-2 rounded-md text-xs transition-colors disabled:bg-bg/30 disabled:cursor-not-allowed"
          [class.bg-primary/10]="isSelected(option.value)" [class.text-primary]="isSelected(option.value) && !getTextColor()"
          [class.hover:bg-bg]="!option.disabled && !isDisabled()"
          [class.cursor-pointer]="!option.disabled && !isDisabled()"
          [class.cursor-not-allowed]="option.disabled || isDisabled()" [class.pointer-events-none]="readOnly()"
          [ngClass]="getTextColor() ? getOptionClasses(option) : { 'text-text-strong': true }">
          {{ option.label }}
        </button>
        }
        }
      </div>
    </div>
    }
  </div>

  @if (error()) {
  <p class="mt-1 text-sm text-error" [id]="name() + '-help'">
    {{ error() }}
  </p>
  } @else if (hint()) {
  <p class="mt-1 text-sm text-text-muted" [id]="name() + '-help'">
    {{ hint() }}
  </p>
  }
</div>
